import { ChangeEvent, FunctionComponent, useState } from "react";
import { FormControl, Box } from "@mui/material";
import { useDispatch } from "react-redux";
import TextField from "@mui/material/TextField";

import { setBookingInfo } from "../../../../state/ducks/booking";
import { useSelector } from "../../../../hooks/useSelector";
import PrivacyDropdown from "../../../../components/Buttons/PrivacyInformation/PrivacyDropdown";
import PhoneNumberInputField from "../../../../components/FormControls/PhoneNumberInputField/PhoneNumberInputField";
import { PhoneNumber } from "../../../../types/bookingTypes";
import { isValidEmail } from "../../../../utils/validation";

export type Props = {};

const ContactInfo: FunctionComponent<Props> = () => {
  const dispatch = useDispatch();
  const booking = useSelector((state) => state.bookingReducer.booking);

  const handleChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    dispatch(setBookingInfo(event.target.name, event.target.value));
  };

  const [emailError, setEmailError] = useState<string | null>(null);
  
  const handleBlurEmail = () => {
    if (!isValidEmail(booking.customerEmail)) {
      setEmailError('Eposten må være gyldig.');
    } else {
      setEmailError(null);
    }
  };

  const handleChangePhoneNumber = (value: PhoneNumber) => {
    dispatch(setBookingInfo("customerPhone", value));
  };

  return (
    <Box
      sx={{
        display: "grid",
        alignItems: "start",
        gridTemplateColumns: "1fr 1fr",
        gridGap: 10,
        "@media (max-width:600px)": {
          gridTemplateColumns: "1fr",
        },
      }}
    >
      <Box 
        sx={{
          display: "grid",
          gridGap: 10,
        }}
      >
        <FormControl variant="standard">
          <TextField
            variant="outlined"
            id="customer-firstname-input"
            data-cy="customer-firstname-field"
            name="firstname"
            label="Fornavn"
            autoComplete="given-name"
            value={booking.firstname}
            onChange={handleChange}
          />
        </FormControl>
        <FormControl variant="standard">
          <TextField
            variant="outlined"
            id="customer-surname-input"
            data-cy="customer-surname-field"
            name="surname"
            label="Etternavn"
            autoComplete="family-name"
            value={booking.surname}
            onChange={handleChange}
          />
        </FormControl>

        <PhoneNumberInputField
          initValue={booking.customerPhone}
          onChange={handleChangePhoneNumber}
        />
        <FormControl variant="standard">
          <TextField
            name="customerEmail"
            data-cy="customer-email-field"
            variant="outlined"
            placeholder="Epost-addresse"
            autoComplete="email"
            inputMode="email"
            type="email"
            label="Epost-addresse"
            value={booking.customerEmail}
            onChange={handleChange}
            onBlur={handleBlurEmail}
            error={emailError !== null}
            helperText={emailError}
          />
        </FormControl>
      </Box>
      <Box>
        <PrivacyDropdown />
      </Box>
    </Box>
  );
};

export default ContactInfo;
